export const disablePageScroll = (offset = 0) => {
  setTimeout(() => {
    const doc = document.documentElement;
    doc.style.position = 'fixed';
    doc.style.top = offset + 'px';
    doc.style.left = '0px';
    doc.style.right = '0px';
  }, 350);
};

export const enablePageScroll = () => {
  const doc = document.documentElement;
  doc.style.position = 'relative';
  doc.style.removeProperty('top');
};
